/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { MediaType } from "../types";

const scheduledLiveScreenMediaTypes = new Set<string>([
  MediaType.Live,
  MediaType.Match,
  MediaType.Event,
  MediaType.FootballEvent,
  MediaType.Program,
  MediaType.Premiere,
  MediaType.MovieNight,
]);

export const isScheduledLiveScreenMediaType = (mediaType?: string): boolean =>
  !!mediaType && scheduledLiveScreenMediaTypes.has(mediaType);
